import {Component, ElementRef, ViewChild} from '@angular/core';
import {DataSource} from '@angular/cdk/collections';
import {MdPaginator, MdSort} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import'rxjs/add/operator/startWith';
import'rxjs/add/observable/merge';
import'rxjs/add/observable/fromEvent';
import'rxjs/add/operator/map';
import'rxjs/add/operator/distinctUntilChanged';
import'rxjs/add/operator/debounceTime';
/**
 * \@title Feature-rich data table
 */
export class TableOverviewExample {
  displayedColumns = ['select', 'userId', 'userName', 'progress', 'color'];
  exampleDatabase = new ExampleDatabase();
  selection = new SelectionModel<string>(true, []);
  dataSource: ExampleDataSource | null;

   paginator: MdPaginator;
   sort: MdSort;
   filter: ElementRef;
/**
 * @return {?}
 */
ngOnInit() {
    this.dataSource = new ExampleDataSource(this.exampleDatabase, this.paginator, this.sort);
    Observable.fromEvent(this.filter.nativeElement, 'keyup')
        .debounceTime(150)
        .distinctUntilChanged()
        .subscribe(() => {
          if (!this.dataSource) { return; }
          this.dataSource.filter = this.filter.nativeElement.value;
        });
  }
/**
 * @return {?}
 */
isAllSelected(): boolean {
    if (!this.dataSource) { return false; }
    if (this.selection.isEmpty()) { return false; }

    if (this.filter.nativeElement.value) {
      return this.selection.selected.length == this.dataSource.renderedData.length;
    } else {
      return this.selection.selected.length == this.exampleDatabase.data.length;
    }
  }
/**
 * @return {?}
 */
masterToggle() {
    if (!this.dataSource) { return; }

    if (this.isAllSelected()) {
      this.selection.clear();
    } else if (this.filter.nativeElement.value) {
      this.dataSource.renderedData.forEach(data => this.selection.select(data.id));
    } else {
      this.exampleDatabase.data.forEach(data => this.selection.select(data.id));
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'table-overview-example',
  styleUrls: ['table-overview-example.css'],
  templateUrl: 'table-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'paginator': [{ type: ViewChild, args: [MdPaginator, ] },],
'sort': [{ type: ViewChild, args: [MdSort, ] },],
'filter': [{ type: ViewChild, args: ['filter', ] },],
};
}

function TableOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
TableOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TableOverviewExample.ctorParameters;
/** @type {?} */
TableOverviewExample.propDecorators;
/** @type {?} */
TableOverviewExample.prototype.displayedColumns;
/** @type {?} */
TableOverviewExample.prototype.exampleDatabase;
/** @type {?} */
TableOverviewExample.prototype.selection;
/** @type {?} */
TableOverviewExample.prototype.dataSource;
/** @type {?} */
TableOverviewExample.prototype.paginator;
/** @type {?} */
TableOverviewExample.prototype.sort;
/** @type {?} */
TableOverviewExample.prototype.filter;
}

/**
 * Constants used to fill up our data base.
 */
const COLORS = ['maroon', 'red', 'orange', 'yellow', 'olive', 'green', 'purple',
  'fuchsia', 'lime', 'teal', 'aqua', 'blue', 'navy', 'black', 'gray'];
const /** @type {?} */ NAMES = ['Maia', 'Asher', 'Olivia', 'Atticus', 'Amelia', 'Jack',
  'Charlotte', 'Theodore', 'Isla', 'Oliver', 'Isabella', 'Jasper',
  'Cora', 'Levi', 'Violet', 'Arthur', 'Mia', 'Thomas', 'Elizabeth'];

export interface UserData {
  id: string;
  name: string;
  progress: string;
  color: string;
}
/**
 * An example database that the data source uses to retrieve data for the table.
 */
export class ExampleDatabase {
/**
 * Stream that emits whenever the data has been modified.
 */
dataChange: BehaviorSubject<UserData[]> = new BehaviorSubject<UserData[]>([]);
/**
 * @return {?}
 */
get data(): UserData[] { return this.dataChange.value; }
constructor() {
    // Fill up the database with 100 users.
    for (let i = 0; i < 100; i++) { this.addUser(); }
  }
/**
 * Adds a new user to the database.
 * @return {?}
 */
addUser() {
    const /** @type {?} */ copiedData = this.data.slice();
    copiedData.push(this.createNewUser());
    this.dataChange.next(copiedData);
  }
/**
 * Builds and returns a new User.
 * @return {?}
 */
private createNewUser() {
    const /** @type {?} */ name =
        NAMES[Math.round(Math.random() * (NAMES.length - 1))] + ' ' +
        NAMES[Math.round(Math.random() * (NAMES.length - 1))].charAt(0) + '.';

    return {
      id: (this.data.length + 1).toString(),
      name: name,
      progress: Math.round(Math.random() * 100).toString(),
      color: COLORS[Math.round(Math.random() * (COLORS.length - 1))]
    };
  }
}

function ExampleDatabase_tsickle_Closure_declarations() {
/**
 * Stream that emits whenever the data has been modified.
 * @type {?}
 */
ExampleDatabase.prototype.dataChange;
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class ExampleDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
/**
 * @return {?}
 */
get filter(): string { return this._filterChange.value; }
/**
 * @param {?} filter
 * @return {?}
 */
set filter(filter: string) { this._filterChange.next(filter); }

  filteredData: UserData[] = [];
  renderedData: UserData[] = [];
/**
 * @param {?} _exampleDatabase
 * @param {?} _paginator
 * @param {?} _sort
 */
constructor(private _exampleDatabase: ExampleDatabase,
private _paginator: MdPaginator,
private _sort: MdSort) {
    super();

    // Reset to the first page when the user changes the filter.
    this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
  }
/**
 * Connect function called by the table to retrieve one stream containing the data to render.
 * @return {?}
 */
connect(): Observable<UserData[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const /** @type {?} */ displayDataChanges = [
      this._exampleDatabase.dataChange,
      this._sort.sortChange,
      this._filterChange,
      this._paginator.page,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      // Filter data
      this.filteredData = this._exampleDatabase.data.slice().filter((item: UserData) => {
        let /** @type {?} */ searchStr = (item.name + item.color).toLowerCase();
        return searchStr.indexOf(this.filter.toLowerCase()) != -1;
      });

      // Sort filtered data
      const /** @type {?} */ sortedData = this.sortData(this.filteredData.slice());

      // Grab the page's slice of the filtered sorted data.
      const /** @type {?} */ startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
      return this.renderedData;
    });
  }
/**
 * @return {?}
 */
disconnect() {}
/**
 * Returns a sorted copy of the database data.
 * @param {?} data
 * @return {?}
 */
sortData(data: UserData[]): UserData[] {
    if (!this._sort.active || this._sort.direction == '') { return data; }

    return data.sort((a, b) => {
      let /** @type {?} */ propertyA: number|string = '';
      let /** @type {?} */ propertyB: number|string = '';

      switch (this._sort.active) {
        case 'userId': [propertyA, propertyB] = [a.id, b.id]; break;
        case 'userName': [propertyA, propertyB] = [a.name, b.name]; break;
        case 'progress': [propertyA, propertyB] = [a.progress, b.progress]; break;
        case 'color': [propertyA, propertyB] = [a.color, b.color]; break;
      }

      let /** @type {?} */ valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      let /** @type {?} */ valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction == 'asc' ? 1 : -1);
    });
  }
}

function ExampleDataSource_tsickle_Closure_declarations() {
/** @type {?} */
ExampleDataSource.prototype._filterChange;
/** @type {?} */
ExampleDataSource.prototype.filteredData;
/** @type {?} */
ExampleDataSource.prototype.renderedData;
/** @type {?} */
ExampleDataSource.prototype._exampleDatabase;
/** @type {?} */
ExampleDataSource.prototype._paginator;
/** @type {?} */
ExampleDataSource.prototype._sort;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
